import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import LoadingSpinner from "../common/LoadingSpinner";
import PropTypes from "prop-types";
import "../../styles/components/FilterModal.css";

const SymbolsModal = ({
  showModal,
  handleClose,
  addFilter,
  fieldId,
  value,
  headerName,
}) => {
  const [loading, setLoading] = useState(false);
  const [symbolArray, setSymbolArray] = useState([]);
  const [uniqueSymbols, setUniqueSymbols] = useState([]);

  useEffect(() => {
    // Function to process symbols, remove spaces, and remove duplicates
    if (value) {
      // console.log("Processing symbols:", value);
      const symbols = value.split(",").map((symbol) => symbol.trim());
      setSymbolArray(symbols);
      const unique = [...new Set(symbols)];
      setUniqueSymbols(unique);
      // console.log("Unique symbols:", unique);
    } else {
      // console.log("No value provided.");
      setSymbolArray([]);
      setUniqueSymbols([]);
    }
  }, [value]);

  const handleApply = async () => {
    setLoading(true);
    try {
      await addFilter(fieldId, uniqueSymbols.join(","), headerName);
    } catch (error) {
      console.error("Error applying filter:", error);
      // Optionally handle the error (e.g., show a toast notification)
    } finally {
      setLoading(false);
      handleClose();
    }
  };

  // Use the File System Access API to allow the user to choose a folder and file name
  const handleDownload = async () => {
    try {
      // Check if the browser supports the File System Access API
      if (window.showSaveFilePicker) {
        // Show the file picker to the user to select file name and folder
        const options = {
          suggestedName: "unique_symbols.txt", // Suggest a default name
          types: [
            {
              description: "Text Files",
              accept: { "text/plain": [".txt"] },
            },
          ],
        };
        const fileHandle = await window.showSaveFilePicker(options);
        const writableStream = await fileHandle.createWritable();

        // Write the file content
        await writableStream.write(uniqueSymbols.join(", "));
        await writableStream.close();
      } else {
        // Fallback: If the API is not available, use the old method
        const element = document.createElement("a");
        const file = new Blob([uniqueSymbols.join(", ")], {
          type: "text/plain",
        });
        element.href = URL.createObjectURL(file);
        element.download = "unique_symbols.txt";
        document.body.appendChild(element); // Required for this to work in FireFox
        element.click();
      }
    } catch (error) {
      console.error("Error during file download:", error);
      // Optionally handle error with a notification
    }
  };

  return (
    <Modal
      show={showModal}
      onHide={handleClose}
      size="lg"
      className="filter-modal bounce-in"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {headerName} - {uniqueSymbols.length} remaining,{" "}
          {symbolArray.length - uniqueSymbols.length} duplicates removed
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="filter-modal-body">
          <h5>Remaining Symbols:</h5>
          <div style={{ maxHeight: "500px", overflowY: "auto" }}>
            {uniqueSymbols.join(", ")}{" "}
            {/* Join unique symbols with a comma and space */}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          className="btn-animate"
          onClick={handleApply}
          disabled={loading || uniqueSymbols.length === 0}
        >
          {loading ? <LoadingSpinner /> : "Apply"}
        </Button>
        <Button
          variant="success"
          className="btn-animate"
          onClick={handleDownload}
          disabled={loading || uniqueSymbols.length === 0}
        >
          Download
        </Button>
        <Button variant="secondary" className="btn-animate" onClick={handleClose} disabled={loading}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

SymbolsModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  addFilter: PropTypes.func.isRequired,
  fieldId: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  headerName: PropTypes.string.isRequired,
};

export default SymbolsModal;
